
import '../../css/svformwerror.css'
import {  Link } from "react-router-dom"

import dgasyncValidate from './dgasyncValidate'
import {flyLoadVpcData as loadAccount, mailIuser } from '../../redux/svractions_cosmos/svflyreviewActions_cosmos'

import { reduxForm , Field, startSubmit, formValueSelector} from 'redux-form'
import {SVVPCFORM} from '../../constants'


//import { Icon } from 'antd'
import {SV_SOJ_ORCMOCK_ADDRESS} from '../../constants'
import { Icon,  Button as SVAButton } from 'antd';

const React = require('react')

const {connect}  = require("react-redux")

const _ = require('lodash')



const selector = formValueSelector(SVVPCFORM)

/*svf6 start*/

const required = value => (value || typeof value === 'number' ? undefined : 'Required')

export const minLength = min => value =>
  value && value.length < min ? `Must be ${min} characters or more` : undefined
export const minLength2 = minLength(2)

const email = value =>
  value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
    ? 'Invalid email address'
    : undefined
const tooYoung = value =>
  value && value < 13
    ? 'You do not meet the minimum age requirement!'
    : undefined
const aol = value =>
  value && /.+@aol\.com/.test(value)
    ? 'Really? You still use AOL for your email?'
    : undefined
const alphaNumeric = value =>
  value && /[^a-zA-Z0-9 ]/i.test(value)
    ? 'Only alphanumeric characters'
    : undefined
export const phoneNumber = value =>
  value && !/^(0|[1-9][0-9]{9})$/i.test(value)
    ? 'Invalid phone number, must be 10 digits'
    : undefined
/*svf6 end*/

let svChange = (values, dispatch, props, valuesPrev)=>{
    console.log('sv vpcForm  change')
    console.log(values)
  }


const renderField = ({
    input,
    label,
    type,
    meta: { asyncValidating, touched, error }
  }) => (
    
     
      
      <div className={asyncValidating ? 'async-validating' : ''}>
          
        <input className="form-control" {...input} type={type} placeholder={label} />
        {touched && error && <span className="sv-form-err" >{error}</span>}
      </div>
   
  )
  
  
  let validate =(formData)=>{
    console.log('sv--valudare fprmData')
      console.log(validate)
        const errors={}
        if(!formData){
            console.log('validate: sv formData null issue')
            return errors
        }
       
        if(!formData.digitalCode){
            errors.digitalCode= 'Required'
        }
        if(!formData.cvv){
            errors.email= 'Required'
        }
     
       
        return errors
    
    }
    
    let warn= (formData)=>{
        const o = {}
        if(!formData){
            console.log('sv gene null issue')
            return o
        }
       
        return o
    }

    class FlyDigVerifyFormBus extends React.Component{

        fsHome(){
            return (
                
                        <SVAButton style={{fontSize:'12px', padding:'5px', color:'#ffffff', backgroundColor:'#e91b1b'}} type="primary" shape="round"  size="{size}" ><Link to={`/svlogin`}> My Reservations   </Link></SVAButton>
            
                   )
        }
        loadGene(e){
            console.log(e)
        }
        constructor(props){
            
            super(props)
            let me = this
            this.loadGene = this.loadGene.bind(this)
            this.fsHome = this.fsHome.bind(this)
            
            this.mailDtokenCurryParams = this.mailDtokenCurryParams.bind(me)
           
        }

        componentWillMount()	{
            console.log('sv--call my_data_dtoken  should needs addressid action load to gtethe formvalues pdForm')
           // const {   my_data_dtoken} = this.props
             console.log('sv-- PaymentCard  PaymentData custProfile  from SVWizard+')
          
           let my_data_dtoken = {
            "email": "suelb22@yahoo.com",
            "subject": "Reservation Details",
            "customerId": "-1",
            "status": "OK",
            "digitalCode": "444444"
        }
        
            console.log(my_data_dtoken)
             console.log('sv--PaymentCard dcustProfile from  SVWizrd end')
             if( my_data_dtoken && (my_data_dtoken.email.length > 0)){
                console.log('sv--PaymentCard dcustProfile from  SVWizrd calls load ')
                console.log(my_data_dtoken)
                //return dummy
                this.props.load(my_data_dtoken)
             }
            
            
        console.log('sbv--sjourn id ****+++++++++++++++++++++++++++ we will use _doc as the space has details of sohourn as single flat indxex:')
    
        }
        mailDtokenCurryParams = (param1, ctx)=>(event)=>{
            let me = ctx
            let um = 'admin@yahoo.com'
            let custProfile = null
            
           
   
            if( ctx.props.initialValues &&  ctx.props.initialValues.id && (ctx.props.initialValues.id.length > 2) ){
               
                um =  ctx.props.initialValues.id
                custProfile =ctx.props.custProfile
                if(custProfile && custProfile.customerId){
                    custProfile = {
                        "customerId" : "-131"
                    }
                }else{
                    custProfile = {
                        "customerId" : "-131"
                    }
                }
                console.log(ctx)

               //console.log('sv F5 email Param1 param1 null ', param1)
                console.log('sv F5 mailDtokenCurryParams curry')
                console.log(um)
                let obData = {
                    "um":um,
                    "custProfile": custProfile
                }
                me.props.mailIuser(obData)
            }else{
                console.log('sv F5 email is null canot email ')
                param1 = 'samb333@gmx.com'
            }
            me.currentSelection = um
           
        }

        render(){
            console.log('sv... FlyDigVerifyFormBusCom')
            const { handleSubmit, pristine, error,reset, submitting } = this.props
            const me = this 
            //me.gene = gene
    
            
            console.log(this.props)
            const {custProfile} = this.props
            return (

         <div>
               
            <form  onSubmit={handleSubmit}>
                <div className="rev-row">
                        <div className="card card--raised with-shadow">

                                 <div className="form-group">
                                    <label htmlFor="email">  Email <span class="svr-required">*</span></label>
                                    <Field
                                            id="email"
                                            name="email"
                                            type="text"
                                            placeholder="mm@yahoo.com"
                                            component={renderField}
                                            className="form-control"
                                            validate= {[required,minLength2,email]}
                                    />
                                </div>
                                <p className="right-sd-content"> <span  onClick={  this.mailDtokenCurryParams("suelb22@yahoo.com", this)}><Icon  style={{ color: '#e30b29' }} type="delete" theme="filled" /></span></p>
              
                                <div className="form-group">
                                    <label htmlFor="digitalCode">Verification Code <span class="svr-required">*</span></label>
                                    <Field
                                            id="digitalCode"
                                            name="digitalCode"
                                            type="text"
                                            placeholder=" 123123"
                                            component={renderField}
                                            className="form-control"
                                           
                                    />
                                </div>




                        </div>
                </div>

                <div>
                    <button type="submit" className="btn btn-success" disabled={pristine || error || submitting}>
                    Next - Guest Details
                    </button>
       
                </div>

            </form>

                
                
                
         </div>

            )

        }

    }



const vpcForm = reduxForm({

    form:SVVPCFORM,
   // validate:validate,
    asyncValidate: dgasyncValidate,
    asyncBlurFields: ['digitalCode'],
    warn:warn,
    //onSubmit:svsubmit,
    onChange:svChange,
    enableReinitialize:true,
    keepDirtyOnReinitialize:true

})(FlyDigVerifyFormBus)


let FlyDigVerifyFormBusCom =connect((state=>{

    let plucked = state.movies
   
    let my_data_dtoken = state.flyreviewView.my_data_dtoken
    let custProfile = state.flyreviewView.custProfile
   
    
    let o = {initialValues:plucked.vpcData, "my_data_dtoken":my_data_dtoken ,  "custProfile":custProfile}
    selector(state, 'id')
    console.log('sv  my_data_dtoken and initialValues  info')
    console.log(o)
    return o
}),{
   // load:loadPcAction,
   mailIuser:mailIuser,
   load:loadAccount,
    startSubmit:startSubmit
   
   // loadGeneTemplate:loadGeneTemplate

    
})(vpcForm)





export default FlyDigVerifyFormBusCom